module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#rain",
      toString: function () {
        return this.url;
      }
    }